import { Box, CardMedia } from "@mui/material";

export default function ResetPasswordIcon() {
  return (
    <Box sx={{ width: "60px", height: "60px" }}>
      <CardMedia component="img" image={`/icons/ResetPasswordIcon.svg`} />
    </Box>
  );
}
